/** FAQ Q&A — question on the first line, multi-line answer below; pairs separated by `---`. */
export interface FaqRow {
  question: string;
  answer: string;
}

export const FAQ_MAX_ITEMS = 8;

const FAQ_PAIR_SEP = '\n\n---\n\n';

/** Reads FAQ pairs. Blank pairs are dropped; at most {@link FAQ_MAX_ITEMS} kept. */
export function readFaqRows(raw: string): FaqRow[] {
  const trimmed = raw.trim();
  if (!trimmed) return [];
  return trimmed
    .split(/\n\n---\n\n|\n---\n/)
    .map((chunk) => {
      const lines = chunk.replace(/^\n+|\n+$/g, '').split('\n');
      const question = (lines[0] ?? '').trim();
      const answer = lines.slice(1).join('\n').trim();
      return { question, answer };
    })
    .filter((row) => row.question || row.answer)
    .slice(0, FAQ_MAX_ITEMS);
}

export function writeFaqRows(rows: readonly FaqRow[]): string {
  return rows
    .map((row) => ({
      question: row.question.trim(),
      answer: row.answer.trim(),
    }))
    .filter((row) => row.question || row.answer)
    .slice(0, FAQ_MAX_ITEMS)
    .map((row) => (row.answer ? `${row.question}\n${row.answer}` : row.question))
    .join(FAQ_PAIR_SEP);
}
